import React, { useEffect, useState } from "react";
import useStore from "../store/store";
import { getLog, getSeatReport } from "../hooks/Log";
import {
  DataGrid,
  GridCallbackDetails,
  GridColDef,
  GridToolbar,
} from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { COLORS } from "./constants";
import MyTable from "./MyTable";

const columns = [
  {
    field: "office",
    headerName: "Office",
    width: 80,
  },
  {
    field: "timestamp",
    headerName: "Datetime",
    width: 150,
  },
  {
    field: "seat_id",
    headerName: "Seat#",
    type: "number",
    width: 80,
  },
  // {
  //   field: "old_user",
  //   headerName: "Old",
  //   width: 180,
  // },
  {
    field: "user",
    headerName: "Name",
    width: 180,
  },
];

const reportColumns = [
  {
    field: "name",
    headerName: "Name",
    width: 180,
  },
  {
    field: "days",
    headerName: "Days",
    width: 100,
  },
];
let columns1 = [];

export default function Report() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const setOffice = useStore((state) => state.setOffice);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [log, setLog] = useState([]);
  const [report, setReport] = useState([]);
  const [selectedOffice, setSelectedOffice] = React.useState("");

  const handleChange = (event) => {
    setSelectedOffice(event.target.value);
  };

  useEffect(() => {
    setOffice("");
    const initLog = async () => {
      const log = await getLog(startDate, endDate, "");
      setLog(log);
    };

    initLog();
  }, []);

  const handleClick = async () => {
    if (endDate < startDate) {
      alert("Check dates");
      return;
    }
    const log = await getLog(startDate, endDate, selectedOffice);
    setLog(log);
    setReport([]);
  };

  const handleGAReportClick = async () => {
    if (endDate < startDate) {
      alert("Check dates");
      return;
    }
    if (selectedOffice === "") {
      alert("Select office");
      return;
    }
    const report = await getSeatReport(startDate, endDate, selectedOffice);
    console.log(report);

    if (report) {
      columns1 = [...reportColumns];
      for (let key in report[0]) {
        if (key.startsWith("_")) {
          const title = key.substring(1).replace("_", "/");
          console.log(key, title);
          columns1.push({
            field: key,
            headerName: title,
            type: "number",
            width: 50,
            // renderCell: (params) => {
            //   let ret = "";
            //   if (params.value === 1) ret = "1";
            //   return ret;
            // },
          });
        }
      }

      console.log(columns1);

      setReport(report);
      setLog([]);
    }
  };

  const handlePageSizeChange = (pageSize, details) => {
    setRowsPerPage(pageSize);
  };

  console.log("report: ", report);
  console.log("report.length: ", report.length);

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <div
          style={{
            margin: "20px 0px",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <FormControl fullWidth sx={{ width: "100px" }}>
            <InputLabel id="demo-simple-select-label">Office</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedOffice}
              label="Office"
              onChange={handleChange}
            >
              <MenuItem value={"NY"}>NY</MenuItem>
              <MenuItem value={"TX"}>TX</MenuItem>
              <MenuItem value={""}>All</MenuItem>
            </Select>
          </FormControl>
          <DesktopDatePicker
            label="Start Date"
            inputFormat="MM/dd/yyyy"
            value={startDate}
            onChange={(newValue) => {
              setStartDate(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
          <DesktopDatePicker
            label="End Date"
            inputFormat="MM/dd/yyyy"
            value={endDate}
            onChange={(newValue) => {
              setEndDate(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
          <Button onClick={handleClick} variant="outlined">
            Refresh
          </Button>
          <Button onClick={handleGAReportClick} variant="outlined">
            GA Report
          </Button>
        </div>
      </LocalizationProvider>
      {log.length > 0 && (
        <DataGrid
          rows={log}
          columns={columns}
          pageSize={rowsPerPage}
          onPageSizeChange={handlePageSizeChange}
          rowsPerPageOptions={[1, 5, 10, 15, 20, 25]}
          // checkboxSelection
          // disableSelectionOnClick
          // getRowId ={(row: ActionsDetail) => row.SeqNo}
          density="compact"
          autoHeight
          // pagination={true}
          components={{
            Toolbar: GridToolbar, // ツールバーを指定する
          }}
          sx={{
            ".MuiDataGrid-columnSeparator": {
              display: "none",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: COLORS.GRID_HEADER_BACKGROUND,
            },
          }}
          disableSelectionOnClick
        />
      )}

      {/* <pre style={{ fontSize: 10 }}>{JSON.stringify(log, null, 4)}</pre> */}

      {report.length > 0 && (
        <DataGrid
          rows={report}
          columns={columns1}
          pageSize={50}
          // onPageSizeChange={handlePageSizeChange}
          // rowsPerPageOptions={[1, 5, 10, 15, 20, 25]}
          // checkboxSelection
          // disableSelectionOnClick
          getRowId={(row) => row.name}
          density="compact"
          autoHeight
          // pagination={true}
          components={{
            Toolbar: GridToolbar, // ツールバーを指定する
          }}
          sx={{
            ".MuiDataGrid-columnSeparator": {
              display: "none",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: COLORS.GRID_HEADER_BACKGROUND,
            },
          }}
          disableSelectionOnClick
        />
      )}
    </div>
  );
}
